import { setManuallyClosed } from 'app/context/OpenState/useManuallyClosed';
import { create } from 'zustand';

export interface OpenStateStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  hasOpened: boolean;
  setHasOpened: (hasOpened: boolean) => void;
  halfOpen: boolean;
  setHalfOpen: (halfOpen: boolean) => void;
}

export const defaultOpenState = {
  isOpen: false,
  hasOpened: false,
  halfOpen: false,
};

export const useOpenStateStore = create<OpenStateStore>((set) => ({
  ...defaultOpenState,
  setIsOpen: (isOpen: boolean) =>
    set((state) => {
      const newState = { ...state, isOpen };

      if (isOpen === false) {
        setManuallyClosed(true);
      }

      if (!state.hasOpened && isOpen) {
        newState.hasOpened = true;
      }
      if (state.hasOpened && isOpen === false && state.halfOpen) {
        newState.halfOpen = false;
      }
      if (isOpen === true && state.halfOpen) {
        newState.halfOpen = false;
      }

      return newState;
    }),
  setHasOpened: (hasOpened: boolean) => set({ hasOpened }),
  setHalfOpen: (halfOpen: boolean) => set({ halfOpen }),
}));

export function resetOpenStateStore() {
  useOpenStateStore.setState(defaultOpenState);
}
